import _taggedTemplateLiteral from "/Users/diego.sampaio/olx/connecting/chat-frontend/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject, _templateObject2;
import styled, { css } from 'styled-components';
export const themes = {
  default: {
    backgroundColor: '--color-neutral-130',
    svgColor: '--color-neutral-70',
    opacity: 0.8,
    hover: {
      backgroundColor: '--color-neutral-130',
      svgColor: '--color-neutral-70'
    },
    focus: {
      backgroundColor: '--color-neutral-130',
      svgColor: '--color-neutral-70'
    },
    disabled: {
      backgroundColor: '--color-neutral-110',
      svgColor: '--color-neutral-120'
    }
  },
  inverted: {
    opacity: 1,
    backgroundColor: '--color-neutral-70',
    svgColor: '--color-neutral-130',
    hover: {
      backgroundColor: '--color-neutral-90',
      svgColor: '--color-secondary-100'
    },
    focus: {
      backgroundColor: '--color-neutral-90',
      svgColor: '--color-secondary-100'
    },
    disabled: {
      backgroundColor: '--color-neutral-90',
      svgColor: '--color-neutral-110'
    }
  }
};
const borderRadius = {
  left: '0px 4px 4px 0px',
  right: '4px 0px 0px 4px',
  up: '0px 0px 4px 4px',
  down: '4px 4px 0px 0px'
};
export const ArrowButtonWrapper = styled.button(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  padding: 0px;\n\n  min-width: ", ";\n  min-height: ", ";\n\n  opacity: ", ";\n  background-color: var(", ");\n  border-radius: ", ";\n  border: none;\n  cursor: pointer;\n  width: ", ";\n  height: ", ";\n\n  svg {\n    color: var(", ");\n    transform: rotate(", "deg);\n  }\n\n  :hover {\n    opacity: 1;\n    background-color: var(", ");\n    svg {\n      color: var(", ");\n    }\n  }\n\n  :focus {\n    opacity: 1;\n    outline: 2px solid var(--color-neutral-130);\n    outline-offset: 2px;\n\n    background-color: var(", ");\n    svg {\n      color: var(", ");\n    }\n  }\n\n  :disabled {\n    pointer-events: none;\n    background-color: var(", ");\n    cursor: default;\n    svg {\n      color: var(", ");\n    }\n  }\n\n  // Only expand clickable area when device is mobile/touch\n  @media only screen and (hover: none) and (pointer: coarse) {\n    ", "\n  }\n"])), props => {
  var _a;
  return (_a = props.dimensions) === null || _a === void 0 ? void 0 : _a.minWidth;
}, props => {
  var _a;
  return (_a = props.dimensions) === null || _a === void 0 ? void 0 : _a.minHeight;
}, props => props.theme.opacity, props => props.theme.backgroundColor, props => borderRadius[props.direction || 'left'] || '0px 4px 4px 0px', props => {
  var _a;
  return (_a = props.dimensions) === null || _a === void 0 ? void 0 : _a.width;
}, props => {
  var _a;
  return (_a = props.dimensions) === null || _a === void 0 ? void 0 : _a.height;
}, props => props.theme.svgColor, props => props.rotation, props => props.theme.hover.backgroundColor, props => props.theme.hover.svgColor, props => props.theme.focus.backgroundColor, props => props.theme.focus.svgColor, props => props.theme.disabled.backgroundColor, props => props.theme.disabled.svgColor, props => props.expandClickableArea && css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        &:after {\n          content: '';\n          position: absolute;\n          width: 60px;\n          height: 80px;\n          ", " 0px;\n        }\n      "])), props.direction == 'right' ? 'right' : 'left'));